import {
  makeAuthenticatedRequest,
  makeAuthenticatedRequestWithHandling,
} from "./api";

export const getPracticesByTopicId = async (topicId) => {
  try {
    return await makeAuthenticatedRequest(`/practices/${topicId}`, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during get Topics By SectionId:", error);
    return { ok: false, error: error };
  }
};

export const createPractice = async (topicId, practiceData) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/practices/${topicId}`,
      "POST",
      practiceData
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during practice creation:", error);
    return { ok: false, error: error };
  }
};

export const updateSetSequence = async (
  topicId,
  reorderedData,
  listType,
  toastText
) => {
  const response = await makeAuthenticatedRequestWithHandling(
    `/topics/${topicId}/reorder?listType=${listType?.listType}`,
    "PATCH",
    reorderedData,
    toastText
  );
  return response;
};

export const deletePractices = async (topicId, _id) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/practices/${topicId}/${_id}`,
      "DELETE"
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete:", error);
    return { ok: false, error: error };
  }
};

//Single Practice Sets

export const getPracticeSetById = async (topicId, practiceSetId) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/practices/${topicId}/${practiceSetId}`,
      "GET"
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during get practice set by id:", error);
    return { ok: false, error: error };
  }
};

export const getAttempts = async (
  classroomId,
  startDate,
  examType,
  studentId = ""
) => {
  try {
    let URL = `/examAttempt/classroom/${classroomId}?from=${startDate}&examType=${examType}`;
    if (studentId) {
      URL += `&userId=${studentId}`;
    }
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        return { ok: true, data: data };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getIeltsAttempts = async (
  classroomId,
  startDate,
  studentId = ""
) => {
  try {
    let URL = `/ielts_exam_attempts/classroom/${classroomId}?from=${startDate}`;
    if (studentId) {
      URL += `&userId=${studentId}`;
    }
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        return { ok: true, data: data };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getAttemptsOfPractice = async (id) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/examAttempt/${id}`,
      "GET"
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during get practice set by id:", error);
    return { ok: false, error: error };
  }
};

export const getAllAttemptsOfSomeExam = async (
  id,
  { isShortForm = false, classroomId = "" }
) => {
  let url = `/examAttempt/exam/${id}`;
  if (isShortForm) {
    url += `?isShortForm=${isShortForm}`;
  }
  if (classroomId) {
    if (url.includes("?")) {
      url += `&classroomId=${classroomId}`;
    } else {
      url += `?classroomId=${classroomId}`;
    }
  }
  try {
    const response = await makeAuthenticatedRequestWithHandling(url, "GET");

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during get practice set by id:", error);
    return { ok: false, error: error };
  }
};

export const getAllAttemptsOfSubject = async ({
  subjectId,
  type,
  page,
  pageSize,
  classroomId,
}) => {
  try {
    let pagination = "";
    let classRoom = "";
    if (page || pageSize) {
      pagination += `&pageNumber=${page}&pageSize=${pageSize}`;
    }
    if (classroomId) {
      classRoom += `&classroomId=${classroomId}`;
    }

    const response = await makeAuthenticatedRequest(
      `/examAttempt/list/${subjectId}?examType=${type}${pagination}${classRoom}`,
      "GET"
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during get practice set by id:", error);
    return { ok: false, error: error };
  }
};

export const updatePracticeSetById = async (
  topicId,
  practiceSetId,
  updatedData
) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/practices/${topicId}/${practiceSetId}`,
      "PATCH",
      updatedData
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during update practice set by id:", error);
    return { ok: false, error: error };
  }
};

export const deletePracticeSetById = async (topicId, practiceSetId) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/practices/${topicId}/${practiceSetId}`,
      "DELETE"
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete practice set by id:", error);
    return { ok: false, error: error };
  }
};

export const addQuestionToPracticeSet = async (
  topicId,
  practiceSetId,
  questionId
) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/practices/${topicId}/${practiceSetId}/questionBank/${questionId}`,
      "POST"
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error adding question to practice set:", error);
    return { ok: false, error: error };
  }
};

export const updateQuestionofPracticeSet = async (
  topicId,
  practiceSetId,
  formData,
  toastText
) => {
  const response = await makeAuthenticatedRequestWithHandling(
    `/practices/${topicId}/${practiceSetId}`,
    "PATCH",
    formData,
    toastText
  );
  return response;
};

export const deleteQuestionFromPracticeSet = async (
  topicId,
  practiceSetId,
  questionId
) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/practices/${topicId}/${practiceSetId}/question/${questionId}`,
      "DELETE"
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      return { ok: false, error: response };
    }

    // Parse the response as JSON
    const data = await response.json();
    // Handle the JSON data
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error deleting question to practice set:", error);
    return { ok: false, error: error };
  }
};
